import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconImportInsert = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12.0001 17.8849C12.1092 17.8849 12.2129 17.8616 12.3065 17.8198L12.4968 17.6972C12.5085 17.6869 12.52 17.6761 12.5312 17.6649L18.7801 11.416C19.0734 11.1227 19.0734 10.6471 18.7801 10.3538C18.4867 10.0604 18.0112 10.0604 17.7178 10.3538L12.7512 15.3204V3.38709C12.7512 2.97227 12.4149 2.63599 12.0001 2.63599C11.5852 2.63599 11.2489 2.97227 11.2489 3.38709V15.3205L6.28227 10.3538C5.98894 10.0604 5.51337 10.0604 5.22004 10.3538C4.92672 10.6471 4.92672 11.1227 5.22004 11.416L11.4689 17.6649L11.4705 17.6665C11.5401 17.7357 11.6198 17.7884 11.7049 17.8247C11.7955 17.8634 11.8953 17.8849 12.0001 17.8849Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4.76598 20.2356C4.76804 20.6486 5.10365 20.9822 5.51668 20.9818L18.4492 20.9695C18.8616 20.9691 19.1962 20.6359 19.1985 20.2236V20.2236C19.2008 19.8075 18.8639 19.4691 18.4478 19.4695L5.51524 19.4818C5.09985 19.4822 4.7639 19.8202 4.76598 20.2356V20.2356Z",
		fill: "currentColor"
	})]
});
export { SvgIconImportInsert as ReactComponent };
